const fieldHubExcel = [
    {colMd: "12", required: true, label: "Excel File", type: "file", name: "excel_file", file_type: ".xlsx, .xls", tagline: "Please populate downloaded Template File and upload it otherwise addition will fail or info will be wrongly filled."}
];

const fieldValExcel = {
    excel_file: '',
    excel_file_data: ''
};
const fieldValidExcel = {
    excel_file: 'required'
};

const data = {
    fieldHubExcel,
    fieldValExcel,
    fieldValidExcel
};

export default data;